import { FC, PropsWithChildren, ReactElement } from 'react';
import { Modal, ModalProps } from 'react-bootstrap';

type AppModalProps = PropsWithChildren<ModalProps>;

const AppModal: FC<AppModalProps> = ({ className, children, ...props }: AppModalProps): ReactElement => {
  return (
    <Modal
      {...props}
      className={`app-modal ${className ?? ''}`}
    >
      {children}
    </Modal>
  );
};

export default AppModal;
